import React from 'react';
import { Dropdown, Grid, Input } from 'semantic-ui-react';

import { FieldLabel } from '../../../styles';
import Button from '../../../components/Button';
import { FiltersState } from '../types';
import { orderByDirOptions, orderByOptions } from '../constants';
import {
  FiltersActionsGroup,
  FiltersActionsRow,
  FiltersSegment
} from '../styles';

type Props = {
  isEstateUser: boolean;
  estateOptions: Array<{ key: string; text: string; value: string }>;
  typeOptions: Array<{ key: string; text: string; value: string }>;
  filters: FiltersState;
  setFilters: React.Dispatch<React.SetStateAction<FiltersState>>;
  onSearch: () => void;
  onClear: () => void;
  showImportButton?: boolean;
  onImportClick?: () => void;
};

const FiltersBar: React.FC<Props> = ({
  isEstateUser,
  estateOptions,
  typeOptions,
  filters,
  setFilters,
  onSearch,
  onClear,
  showImportButton = false,
  onImportClick
}) => {
  return (
    <FiltersSegment>
      <Grid stackable>
        <Grid.Row>
          {!isEstateUser && (
            <Grid.Column computer={4} tablet={16} mobile={16}>
              <FieldLabel>Imobiliária</FieldLabel>
              <div style={{ width: '100%' }}>
                <Dropdown
                  style={{ width: '100%' }}
                  value={filters.estateId || ''}
                  placeholder="Selecionar..."
                  options={estateOptions}
                  search
                  selection
                  onChange={(_, { value }) =>
                    setFilters(prev => ({ ...prev, estateId: (value as string) || '' }))
                  }
                />
              </div>
            </Grid.Column>
          )}

          <Grid.Column computer={4} tablet={16} mobile={16}>
            <FieldLabel>Buscar</FieldLabel>
            <Input
              fluid
              icon="search"
              iconPosition="left"
              placeholder="Endereço, código ou apelido"
              value={filters.search}
              onChange={(_, { value }) =>
                setFilters(prev => ({ ...prev, search: String(value) }))
              }
              onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                if (event.key === 'Enter') onSearch();
              }}
            />
          </Grid.Column>

          <Grid.Column computer={3} tablet={16} mobile={16}>
            <FieldLabel>Tipo do imóvel</FieldLabel>
            <div style={{ width: '100%' }}>
              <Dropdown
                style={{ width: '100%' }}
                value={filters.type || ''}
                placeholder="Todos"
                options={typeOptions}
                search
                selection
                clearable
                onChange={(_, { value }) =>
                  setFilters(prev => ({ ...prev, type: (value as string) || '' }))
                }
              />
            </div>
          </Grid.Column>

          <Grid.Column computer={3} tablet={8} mobile={16}>
            <FieldLabel>Ordenar por</FieldLabel>
            <div style={{ width: '100%' }}>
              <Dropdown
                style={{ width: '100%' }}
                value={filters.orderBy}
                options={orderByOptions}
                selection
                onChange={(_, { value }) =>
                  setFilters(prev => ({ ...prev, orderBy: String(value) }))
                }
              />
            </div>
          </Grid.Column>

          <Grid.Column computer={2} tablet={8} mobile={16}>
            <FieldLabel>Direção</FieldLabel>
            <div style={{ width: '100%' }}>
              <Dropdown
                style={{ width: '100%' }}
                value={filters.orderByDir}
                options={orderByDirOptions}
                selection
                onChange={(_, { value }) =>
                  setFilters(prev => ({
                    ...prev,
                    orderByDir: value as FiltersState['orderByDir']
                  }))
                }
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <FiltersActionsRow>
        <FiltersActionsGroup>
          <Button type="button" text="Pesquisar" onClick={onSearch} />
          <Button light type="button" text="Limpar" onClick={onClear} />
        </FiltersActionsGroup>

        {showImportButton && onImportClick && (
          <Button light type="button" text="Importar imóveis" onClick={onImportClick} />
        )}
      </FiltersActionsRow>
    </FiltersSegment>
  );
};

export default FiltersBar;
